// Constants
export const list_cuentas = () => {
    return {
        list_cuentas: {
            id: {
                namepath: [''],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            name: {
                type: "text",
                label: "Nombre o Razon Social",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
        }
    }
}